(function () {
  'use strict';

  const root = document.querySelector('[data-ptm-root]');
  if (!root) return;

  /* =====================================================
     Reveal / Animaciones
  ===================================================== */
  const revealEls = root.querySelectorAll('.ptm-reveal');

  // Respaldo inmediato para evitar que la home quede invisible
  revealEls.forEach((el) => {
    el.classList.add('is-visible');
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    revealEls.forEach((el) => observer.observe(el));
  }

  /* =====================================================
     Product filters
  ===================================================== */
  const filterButtons = root.querySelectorAll('[data-ptm-filter]');
  const productCards = root.querySelectorAll('.ptm-product-card[data-tags]');

  const aliases = {
    'enduro': [
      'enduro'
    ],
    'hard-enduro': [
      'hard-enduro',
      'hardenduro',
      'hard',
      'spec-b',
      'en1-grand-prix-spec-b'
    ],
    'extreme-hybrid': [
      'extreme-hybrid',
      'extremehybrid',
      'hybrid-range',
      'hybrid',
      'extreme',
      'the-beast',
      'the-monster'
    ],
    'trail-compound': [
      'trail-compound',
      'trail',
      'trailcompound'
    ],
    'the-tough-one': [
      'the-tough-one',
      'tough-one',
      'tough',
      'the-tough-one-spec-a',
      'the-tough-one-spec-b'
    ],
    'big-boy': [
      'big-boy',
      'the-big-boy',
      'bigboy',
      'adventure',
      'adventure-bike'
    ]
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.getAttribute('data-ptm-filter');

      filterButtons.forEach((btn) => {
        btn.classList.remove('is-active');
      });

      button.classList.add('is-active');

      productCards.forEach((card) => {
        const tags = (card.getAttribute('data-tags') || '').toLowerCase();

        const shouldShow =
          filter === 'all' ||
          (aliases[filter] || [filter]).some((key) => tags.includes(key));

        card.classList.toggle('is-hidden', !shouldShow);
      });
    });
  });

  /* =====================================================
     Terrain Logic — colecciones Plews
  ===================================================== */
  const terrainContent = {
    'en1-gp': {
      title: 'EN1 Grand Prix',
      text: 'Línea enfocada en enduro técnico, entrenamiento y competencia. Diseñada para pilotos que buscan tracción controlable, estabilidad en frenada y confianza en terrenos mixtos.',
      bullets: [
        'Recomendada para enduro técnico y sprint enduro.',
        'Buen desempeño en tierra compacta, raíz, lodo y terreno mixto.',
        'Opción ideal para pilotos que buscan rendimiento off-road premium.'
      ]
    },

    'en1-specb': {
      title: 'EN1 Grand Prix Spec B',
      text: 'Versión orientada a pilotos que buscan agarre consistente, control y mayor respuesta en enduro técnico, hard enduro y terrenos de alta exigencia.',
      bullets: [
        'Compuesto Spec B para condiciones exigentes.',
        'Ideal para lodo, raíces, piedra y zonas técnicas.',
        'Pensada para competencia, entrenamiento avanzado y rutas duras.'
      ]
    },

    'en1-extreme': {
      title: 'EN1 Extreme Grand Prix',
      text: 'Colección desarrollada para extreme enduro y condiciones de baja adherencia donde la tracción, el control direccional y la confianza son prioridad.',
      bullets: [
        'Recomendada para terrenos técnicos y extremos.',
        'Buen control en frenada, curva y subidas complicadas.',
        'Ideal para pilotos que exigen máximo agarre off-road.'
      ]
    },

    'beast': {
      title: 'The Beast',
      text: 'The Beast está diseñada para terrenos blandos, lodo, bosque y condiciones donde se necesita máxima mordida y avance constante.',
      bullets: [
        'Excelente opción para lodo y terreno blando.',
        'Pensada para hard enduro, enduro técnico y rutas agresivas.',
        'Tracción trasera para condiciones complicadas.'
      ]
    },

    'monster': {
      title: 'The Monster',
      text: 'The Monster está enfocada en hardpack, roca, terreno técnico seco y rutas donde se necesita estabilidad, contacto y control.',
      bullets: [
        'Recomendada para roca, hardpack y terreno técnico seco.',
        'Buena estabilidad en subidas, frenadas y zonas castigadas.',
        'Ideal para pilotos que buscan respuesta firme y control.'
      ]
    },

    'hybrid-range': {
      title: 'Hybrid Range',
      text: 'Hybrid Range reúne neumáticos Plews para trail técnico, extreme hybrid y rutas mixtas donde se combinan agarre, durabilidad y control.',
      bullets: [
        'Opciones para trail, hard enduro y terrenos mixtos.',
        'Equilibrio entre resistencia, tracción y estabilidad.',
        'Recomendada para pilotos que alternan rutas técnicas y rodadas largas.'
      ]
    },

    'tough-one': {
      title: 'The Tough One',
      text: 'The Tough One está pensada para hard enduro, enduro extremo y terrenos técnicos donde se necesita máxima tracción, resistencia y control en condiciones castigadas.',
      bullets: [
        'Recomendada para hard enduro y rutas técnicas.',
        'Ideal para piedra, raíz, subidas exigentes y terreno roto.',
        'Diseñada para pilotos que buscan agarre agresivo y avance constante.'
      ]
    },

    'big-boy': {
      title: 'Big Boy',
      text: 'Big Boy está enfocada en motos adventure y trail de mayor desplazamiento, ideal para rutas mixtas donde se combinan estabilidad, durabilidad y confianza off-road.',
      bullets: [
        'Recomendada para adventure bike y trail pesado.',
        'Ideal para caminos mixtos, tierra, grava y rutas largas.',
        'Pensada para pilotos que buscan resistencia y control en rodada extendida.'
      ]
    }
  };

  root.querySelectorAll('[data-ptm-terrain]').forEach((button) => {
    button.addEventListener('click', () => {
      const key = button.getAttribute('data-ptm-terrain');
      const url = button.getAttribute('data-url');
      const content = terrainContent[key];
      const panel = root.querySelector('[data-ptm-terrain-panel]');

      if (!content || !panel || !url) return;

      root.querySelectorAll('[data-ptm-terrain]').forEach((btn) => {
        btn.classList.remove('is-active');
      });

      button.classList.add('is-active');

      panel.innerHTML = `
        <span>Recomendación activa</span>
        <h3>${content.title}</h3>
        <p>${content.text}</p>
        <ul>
          ${content.bullets.map((item) => `<li>${item}</li>`).join('')}
        </ul>
        <a class="ptm-btn ptm-btn-red" href="${url}" data-ptm-terrain-link>
          Ver llantas disponibles
        </a>
      `;
    });
  });

  /* =====================================================
     AJAX add to cart
  ===================================================== */
  root.querySelectorAll('[data-ptm-add-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const originalText = button ? button.textContent : '';

      try {
        if (button) {
          button.disabled = true;
          button.textContent = 'Agregando...';
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        });

        if (!response.ok) {
          throw new Error('No se pudo agregar al carrito');
        }

        if (button) {
          button.textContent = 'Agregado';
        }

        const cartResponse = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });

        const cart = await cartResponse.json();

        document.querySelectorAll('.ptm-cart b, [data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });

        setTimeout(() => {
          if (button) {
            button.disabled = false;
            button.textContent = originalText;
          }
        }, 1400);
      } catch (error) {
        if (button) {
          button.disabled = false;
          button.textContent = 'Intentar de nuevo';
        }

        console.error(error);
      }
    });
  });

  /* =====================================================
     Formularios visuales
  ===================================================== */
  root.querySelectorAll('.ptm-b2b-form, .ptm-newsletter-form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const button = form.querySelector('button');
      if (!button) return;

      const originalText = button.textContent;

      button.textContent = 'Recibido';

      setTimeout(() => {
        button.textContent = originalText;
        form.reset();
      }, 1600);
    });
  });
})();